//
class GiftNote extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.timeout = null;
    this.giftNoteCheckbox = this.querySelector('[name="add-gift-note"]');
    this.giftNote = this.querySelector('[name="gift-note"]');
    this.remove = this.querySelector("[data-gift-note-remove]");

    this.remove.addEventListener("click", () => {
      this._setCartNote(null);
      this.giftNote.value = "";
      this.removeAttribute("has-note");
      setTimeout(() => {
        this.giftNoteCheckbox.checked = false;
        this.close();
      }, 500);
    });

    this.giftNoteCheckbox.addEventListener("change", () => {
      if (this.giftNoteCheckbox.checked) {
        this.open();
      } else {
        this.close();
      }
    });

    this.giftNote.addEventListener("input", (e) => {
      this._setCartNote(e.target.value || null);
      this.toggleAttribute("has-note", e.target.value.length);
    });
  }

  open() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    if (this.content) {
      this.content.style.display = "block";
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.height = "auto";
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.display = null;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = `${this.content.scrollHeight}px`;

      window.requestAnimationFrame(() => {
        this.content.style.height = 0;
        this.content.style.opacity = 0;
      });
    }
  }

  get content() {
    return this.querySelector("[data-content]");
  }

  get giftNoteKey() {
    return this.getAttribute("gift-note-key");
  }

  _setCartNote(note) {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      window.updateCart(
        {
          attributes: {
            [this.giftNoteKey]: note,
          },
        },
        {
          sections: [this.sectionId],
        },
      );
    }, 500);
  }

  get sectionId() {
    return this.getAttribute("section-id");
  }
}

if (!customElements.get("gift-note")) {
  customElements.define("gift-note", GiftNote);
}
